import React from "react";
import { connect } from "react-redux";
import { Link, withRouter } from "react-router-dom";
import * as Middleware from "@middlewares/index";

interface PropsInterface {}

interface StateInterface {}

class HasNoProfile extends React.Component<PropsInterface, StateInterface> {
  public render() {
    return (
      <>
        <div className="modal modal--has-no-profile">
          <div className="modal__header">
            <div className="modal__title">Заполните профиль!</div>
            <button
              className="modal__close"
              onClick={() => {
                Middleware.Ui.Modal.close();
              }}
            />
          </div>
          <div className="modal__body">
            <div className="modal__desc">
              Функция доступна только участникам нетворкинга. Заполните информацию о себе и создайте
              страницу вашей компании в{" "}
              <Link to="/cabinet/profile" onClick={() => Middleware.Ui.Modal.closeAll()}>
                профиле
              </Link>
              .
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default withRouter(
  connect(
    (Store: any) => {
      return { Store };
    },
    (Dispatch: any) => {
      return { Dispatch: (action: any) => Dispatch(action) };
    }
  )(HasNoProfile)
);
